export enum CurrentModuleId {
    MAIN = 'MAIN',
    CGP = 'CGP',
    CGP_TUNNEL = 'CGP_TUNNEL',
    SELFCARE = 'SELFCARE'
}

export function currentModuleIdOf(value: string) : CurrentModuleId {
    switch (value) {
        case 'MAIN':
            return CurrentModuleId.MAIN;

        case 'CGP':
            return CurrentModuleId.CGP;

        case 'CGP_TUNNEL':
            return CurrentModuleId.CGP_TUNNEL;

        case 'SELFCARE':
            return CurrentModuleId.SELFCARE;

        default:
            return CurrentModuleId.MAIN;
    }
}

export function valueOfCurrentModuleId(value: CurrentModuleId): string {
    return value;
}
